import { call, put, select, take } from 'redux-saga/effects';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import each from 'lodash/each';

import snakeCase from '../../../utils/snakecaseKeys';
import { dataURItoBlob } from '../../../utils/base64ToFile';
import { dependentFormActions } from '../progress.actions';
import {
  selectDependentFormAssigmentId,
  selectDependentFormProgressMetadata,
  selectDependentPhoneNumberCountryIsoCode,
} from '../selectors';
import * as generalInfoReq from '../general-info-req';
import { redirectToDocuments, redirectToRelation } from './redirect-saga';
import { selectCurrentCountryCode } from '../../profiles/selectors';
import { selectCountryPhoneSettings } from '../../data/selectors';

function appendAvatarToFormData(formData, avatar) {
  if (avatar === null || avatar.indexOf('http') === 0) {
    return null;
  }

  if (avatar.indexOf('data:') === 0) {
    return formData.append(`dependent[avatar]`, dataURItoBlob(avatar));
  }

  formData.append('dependent[avatar]', avatar);
}

function preparePayload(
  { avatar, phoneNumber, ...rest },
  id,
  isoCode,
  countriesPhoneCode,
) {
  const data = omitBy(rest, value => isEmpty(value));
  const formData = new FormData();
  formData.append('id', id);

  const isFullPhoneNumber = !countriesPhoneCode
    .map(({ countryCode }) => countryCode)
    .includes(phoneNumber);

  if (phoneNumber && isFullPhoneNumber) {
    formData.append('dependent[phone_number_country_iso_code]', isoCode);
    formData.append('dependent[phone_number]', phoneNumber);
  }
  appendAvatarToFormData(formData, avatar);
  each(snakeCase(data), (value, key) => {
    formData.append(`dependent[${key}]`, value);
  });
  return formData;
}

export function* sendGeneralInfo(data) {
  const id = yield select(selectDependentFormAssigmentId);
  const countriesPhoneCode = yield select(selectCountryPhoneSettings);
  const metadata = yield select(selectDependentFormProgressMetadata);

  const phoneNumberCountryIsoCode = yield select(selectCurrentCountryCode);
  const dependentPhoneNumberCountryIsoCode = yield select(
    selectDependentPhoneNumberCountryIsoCode,
  );
  const payload = preparePayload(
    data,
    id,
    phoneNumberCountryIsoCode || dependentPhoneNumberCountryIsoCode,
    countriesPhoneCode,
  );
  yield put(generalInfoReq.actions.send(payload));
  /** Wait until success response */
  const { payload: assignment } = yield take(generalInfoReq.consts.SUCCEED);
  yield put(dependentFormActions.updateDependent(assignment));

  if (get(metadata, 'documentationStepEnabled')) {
    yield call(redirectToDocuments, id);
  } else {
    yield call(redirectToRelation, id);
  }
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/send-genera-info-saga.js